import { ClipboardCopyFailReason } from 'core/common/entities';

export const copyToClipboard = async (text: string): Promise<ClipboardCopyFailReason | null> => {
  if (!navigator.clipboard) {
    return ClipboardCopyFailReason.CLIPBOARD_UNAVAILABLE;
  }

  try {
    await navigator.clipboard.writeText(text);

    return null;
  } catch {
    return ClipboardCopyFailReason.WRITE_REJECTED;
  }
};
